<template>
  <Modal
    v-model="_value"
    width="500"
    title='短信设置HIK"两客一危"平台(通道4)'
    @on-visible-change="visibleChange"
    ok-text="发送"
    @on-ok="onOk">
<p>选择归属地：
    <Select v-model="DomainName" style="width: 220px;">
      <Option v-for="item in DomainNameOptions" :value="item.value" :key="item.value">
        {{item.name}}
      </Option>
    </Select>
</p>

  </Modal>
</template>
<script>

  import Vue from 'vue';
  import {mapActions} from 'vuex'
  import store from '@/store'
  import {genQueryParam, genSortParam} from "@/libs/queryparamhelper"

  export default {
    name: 'setuphikdlysjgsmsmodal',
    props: {
      value: {
        type: Boolean,
        default: false
      },
      initValue: null,
      businessUserId: null,
    },
    data() {
      return {
        simNum:null,

        //域名选项
        DomainName:null,
        DomainNameOptions: [
          {name: '中山', value: 'yt.dlysjg.td.gd.gov.cn,30500'},
          {name: '江门', value: 'yt.dlysjg.td.gd.gov.cn,30700'},
          {name: '广州', value: 'ya.dlysjg.td.gd.gov.cn,30100'},
          {name: '佛山', value: 'ye.dlysjg.td.gd.gov.cn,30400'},
        ],
      }
    },
    methods: {
      ...mapActions([
        'ShortMessageServ_Send'
      ]),
      onOk() {
        if (!this.DomainName || this.DomainName === '') {
          this.$Message.error('请选择归属地')
          return
        }
        //共三条短信，1、设置IP或域名。2、设置卡号。3、设置通道使能及协议
        // console.log(this.simNum.substring(6))
        store.dispatch('PositioningDeviceInfoServ_SearchByName',{
          params:{name:this.simNum.substring(6)},
          urlparams:{},
        }).then(res => {

          if (store.getters.get_PositioningDeviceInfo_SearchByNameResult.length >0){

          this.sendSMS('ZIP:3,'+this.DomainName+';A')

          setTimeout(() => {
              this.sendSMS('TEL_ID:3,' + 0 + store.getters.get_PositioningDeviceInfo_SearchByNameResult[0].terminalNum + ',' + this.simNum.substring(6) + ';A')
            }
            ,4000)

            setTimeout(() => {
                this.sendSMS('JT808Ver:3,1;A')
              }
              ,70000)

          setTimeout(() => {
              this.sendSMS('PROTO:3,1,1,6;A')
            }
            ,10000)
          }else {
            this.$Message.error('请检查主机号（卡号）')
          }
        }).catch(err => {
          console.log(err)
        })

      },
      sendSMS (content) {
        if (!this.simNum || this.simNum === '') {
          this.$Message.error('请选择SIM卡号')
          return
        }
        store.dispatch('ShortMessageServ_Send', { params: { simNum: this.simNum, content: content } }).then(() => {
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      visibleChange(val) {
        if(val){
          this.simNum = this._initValue
        }
      }
    },
    computed: {
      _value: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val)
          this.$emit('change', val)
        }
      },
      _businessUserId:{
        get() {
          return this.businessUserId
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      _initValue: {
        get() {
          return this.initValue
        },
        set(val) {
          // this.$emit('input', val);
          // this.$emit('change', val);
        }
      },
      rules () {
        return {
          name: this.nameRules,
          phoneNum: this.phoneNumRules
        }
      }
    },
    mounted() {
      this.$nextTick(() => {

      })
    }
  }
</script>
